const ascSort = (a: number | string, b: number | string) => +a - +b

export default ascSort
